"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slateDemoHtmlToSlateConfig = exports.payloadHtmlToSlateConfig = exports.htmlToSlateConfig = exports.slateDemoSlateToHtmlConfig = exports.payloadSlateToHtmlConfig = exports.slateToHtmlConfig = exports.slateToHtml = exports.htmlToSlate = void 0; // Serializers

var htmlToSlate_1 = require("./serializers/htmlToSlate");

Object.defineProperty(exports, "htmlToSlate", {
  enumerable: true,
  get: function get() {
    return htmlToSlate_1.htmlToSlate;
  }
});

var slateToHtml_1 = require("./serializers/slateToHtml");

Object.defineProperty(exports, "slateToHtml", {
  enumerable: true,
  get: function get() {
    return slateToHtml_1.slateToHtml;
  }
}); // Configuration objects
// slateToDom - renamed to slateToHtml
// slateToHtml uses the same config as slateToDom but it makes sense to rename the config objects in case we want to add a slateToHtml specific config in the future

var dom_1 = require("@slate-serializers/dom");

Object.defineProperty(exports, "slateToHtmlConfig", {
  enumerable: true,
  get: function get() {
    return dom_1.slateToDomConfig;
  }
});
Object.defineProperty(exports, "payloadSlateToHtmlConfig", {
  enumerable: true,
  get: function get() {
    return dom_1.payloadSlateToDomConfig;
  }
});
Object.defineProperty(exports, "slateDemoSlateToHtmlConfig", {
  enumerable: true,
  get: function get() {
    return dom_1.slateDemoSlateToDomConfig;
  }
});

var default_1 = require("./serializers/htmlToSlate/config/default");

Object.defineProperty(exports, "htmlToSlateConfig", {
  enumerable: true,
  get: function get() {
    return default_1.config;
  }
});

var payload_1 = require("./serializers/htmlToSlate/config/payload");

Object.defineProperty(exports, "payloadHtmlToSlateConfig", {
  enumerable: true,
  get: function get() {
    return payload_1.config;
  }
});

var slateDemo_1 = require("./serializers/htmlToSlate/config/slateDemo");

Object.defineProperty(exports, "slateDemoHtmlToSlateConfig", {
  enumerable: true,
  get: function get() {
    return slateDemo_1.config;
  }
});